module.exports = __webpack_public_path__ + "img/less.f135ddcd.svg";